// common js
// 에러 핸들링을 위한 안전한 GSAP 플러그인 등록
try {
  if (typeof gsap !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger, SplitText, CSSRulePlugin, ScrollToPlugin);
  }
} catch (error) {
  console.warn('GSAP plugins registration failed:', error);
}

window.DEBUG = window.location.hash && window.location.hash.includes('debug') ? true : false;

(()=>{
  const md = new MobileDetect(window.navigator.userAgent);
  window.DEVICE = {
    IS_PHONE: md.phone() !== null,
    IS_MOBILE: md.mobile() !== null,
    IS_TABLET: md.tablet() !== null,
    IS_DESKTOP: !(md.mobile() || md.tablet())
  };
})();

window.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
window.addEventListener('DOMContentLoaded', () => {

  // 라이브러리 존재 여부 확인
  if (typeof Lenis === 'undefined' || typeof gsap === 'undefined') {
    console.warn('Required libraries (Lenis, GSAP) not loaded');
    return;
  }

  // Lenis 부드러운 스크롤 초기화
  const lenis = new Lenis({smooth: !window.prefersReducedMotion});

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  window.lenis = lenis; // 전역 접근성 향상

  // DOM 요소 캐싱 및 존재 여부 확인
  const $skipLink = document.querySelector('.skip-link');
  const $header = document.querySelector('#header');
  const $main = document.querySelector('#main');
  const $kv = document.querySelector('[data-section="kv"]');
  const pageType = document.querySelector('#main').getAttribute('data-page-type');
  const headerType = document.querySelector('#main').getAttribute('data-header-type');
  // Skip Link 기능 구현 (접근성 향상)
  if ($skipLink && $main) {
    $skipLink.addEventListener('click', (e) => {
      e.preventDefault();

      try {
        // main 요소가 포커스 가능하도록 tabindex 추가
        if (!$main.hasAttribute('tabindex')) {
          $main.setAttribute('tabindex', '-1');
        }

        // 접근성을 위한 즉시 포커스 (스크린리더 사용자용)
        $main.focus();

        // 부드러운 스크롤 (시각적 사용자용)
        $main.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });

        // ARIA 상태 업데이트
        $skipLink.setAttribute('aria-describedby', 'main');

      } catch (error) {
        console.warn('Skip link navigation failed:', error);
        // 폴백: 단순 스크롤
        window.scrollTo(0, $main.offsetTop);
      }
    });
  }

  // 헤더 상태 관리 (에러 핸들링 포함)
  if ($header && $main) {
    let ticking = false;
    if (pageType && pageType === 'no-kv') {
      $header.classList.add( (headerType === 'dark' ? '--force-dark' : '--force-opaque') );
    }
    const updateHeaderState = (self) => {
      try {
        const scrollTop = window.scrollY;
        const scrollDir = self ? self.direction : 1;
        const headerHeight = $header.clientHeight || 80; // 폴백 값
        const kvHeight = $kv ? $kv.clientHeight : window.innerHeight;

        // 헤더 상태 업데이트
        $header.classList.toggle('--opaque', scrollTop > 20);
        $header.classList.toggle('--hide', scrollTop >= (kvHeight - 5) && scrollDir === 1);

        // 접근성: 헤더 숨김 상태를 스크린리더에 알림
        const isHidden = $header.classList.contains('--hide');
        $header.setAttribute('aria-hidden', isHidden);

      } catch (error) {
        console.warn('Header state update failed:', error);
      }
    };

    // ScrollTrigger 생성 (에러 핸들링 포함)
    try {
      ScrollTrigger.create({
        trigger: $main,
        start: 'top top',
        end: 'bottom top',
        onUpdate: (self)=> {
          updateHeaderState(self);
        }
      });
    } catch (error) {
      console.warn('ScrollTrigger creation failed, using fallback scroll handler:', error);

      // 폴백: 일반 스크롤 이벤트
      window.addEventListener('scroll', () => updateHeaderState(null), { passive: true });
    }

    $header.querySelector('.btn-search').addEventListener('click', (e) => {
      e.preventDefault();
      $header.classList.toggle('--search-active');
      $header.querySelector('.form-input').focus();
    });
  }

  const langSelector = $header.querySelector('.lang-selector');
  const hideLangSelector = () => {
    langSelector.classList.remove('--active');
  }
  langSelector.querySelector('.btn-toggle').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (langSelector.classList.contains('--active') === false) {
      langSelector.classList.add('--active');
    }
    window.addEventListener('click', hideLangSelector, { once: true });
    // window.addEventListener('pointerdown', hideLangSelector, { once: true });
  })

  langSelector.querySelector('.langs').addEventListener('mouseleave', hideLangSelector);
});

